import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { GenericStreamsService } from '../../../../../service/generic-streams.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GenericStepConfigList, GenericStepConfig } from '../../../../../lib/interfaces/generic-streams';
import { EditConfigComponent } from '../edit-config/edit-config.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-select-config',
    standalone: false,
    templateUrl: './select-config.component.html',
    styleUrl: './select-config.component.scss'
})
export class SelectConfigComponent implements OnInit {
    streamService = inject(GenericStreamsService);
    dialog = inject(MatDialogRef<SelectConfigComponent>);

    constructor(private dia: MatDialog) { }

    configList: GenericStepConfigList[] = []
    selectedItem: GenericStepConfigList | undefined
    isLoading: boolean = false;

    destroyRef = inject(DestroyRef);

    async ngOnInit() {
        this.isLoading = true;
        let r = await this.streamService.getGenericConfigList();
        this.isLoading = false;
        if (r === false) return;

        this.configList = r;
    }

    close() {
        this.dialog.close();
    }
    select(item: GenericStepConfigList) {
        this.selectedItem = item;
    }

    save() {
        if (!this.selectedItem) return;

        this.dialog.close(this.selectedItem.id)
    }

    editConfig(cid: string) {
        let editDia = this.dia.open(EditConfigComponent, {
            data: { id: cid },
            disableClose: true,
            restoreFocus: false,
            autoFocus: false
        })
        editDia.keydownEvents().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (event) => {
                if(event.key === 'Escape') {
                    editDia.close();
                }
            }
        })

        editDia.afterClosed().subscribe(async (result) => {
            this.isLoading = true;
            let r = await this.streamService.getGenericConfigList();
            this.isLoading = false;
            if (r === false) return;

            this.configList = r;
        })
    }
}
